import React from 'react';
import { phoneNumberValidation } from '../../Utils/CommonFunctions';

const PhoneNumberField = (props) => {
	const {changeHandler,name,className,placeholder,value,isDisable} = props;	
	return (
		<input 
			onKeyPress={phoneNumberValidation} 
			onChange={changeHandler} 
			type="text" 
			name={name} 
			className={className} 
			placeholder={placeholder} 
			value={value} 
			disabled={isDisable} 
		/>
	);
}

PhoneNumberField.defaultProps = {
	className:'form-control',
	isDisable:false
}

export default PhoneNumberField;